export enum EnumEmployeeRole {
  BASIC = "BASIC",
  HR = "HR",
}

export enum HR {
  "HR" = "HR",
  "HR_LV1" = "HR_LV1",
}
